module.exports = __webpack_public_path__ + "static/img-nibbler-80182f1930981c616e055940bce86fe9.png";